import { Component, Input } from '@angular/core';
import { MultipleSelectOption } from './multiple-select-control';
import { BaseControl } from '../base-control';
import { MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'multiple-select-control',
  templateUrl: './multiple-select-control.component.html',
  styleUrls: ['./multiple-select-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MultipleSelectControlComponent,
    multi: true
  }]
})
export class MultipleSelectControlComponent extends BaseControl {

  @Input() selectOptions: MultipleSelectOption[];

  public addOptionData: boolean = false;
  @Input() itemWidth: string = '24.5%';
  @Input() showSelectAll: boolean = true;
  @Input() showSearch: boolean = true;
  @Input() isInline: boolean = false;
  @Input() columns: number = 3;
  @Input() useIndexValues: boolean = false;
  @Input() lastUpdate: number = null;
  
  private filterOptions;

  public filteredOptions: MultipleSelectOption[];
  optionsMap: Map<string, MultipleSelectOption> = new Map<string, MultipleSelectOption>();

  private searchText: string;
  private searchOptions: any[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.filteredOptions = JSON.parse(JSON.stringify(this.selectOptions));
    this.filteredOptions.forEach(option => this.optionsMap.set(option.id, option));
  }

  ngAfterViewInit() {
    let filterInput = document.getElementById('multiple-select-search-' + this.id);
  }

  onWriteValue(value) {
    if (!Array.isArray(value)) return;
    
    let selectedValues: string[] = value;
    
    if (value) {
      selectedValues.forEach(value => {
        let option: MultipleSelectOption;

        if (this.useIndexValues) option = this.filteredOptions[value];
        else option = this.optionsMap.get(value);

        if (option) option.selected = true;
      });
    }
  }

  sortOptions() {

  }

  allSelected(): boolean {
    return this.selectOptions.every(option => option.selected);
  }

  toggleAllSelected() {
    let toggleValue = true;
    if (this.selectOptions.every(option => option.selected)) toggleValue = false;

    this.selectOptions.forEach(option => option.selected = toggleValue);
  }

  clearSearch() {

  }

  refreshFilterOptions(filterText: string) {
    let options: MultipleSelectOption[] = [];

    options = this.selectOptions.filter(option => !option.hide);

    if (filterText.length > 0) this.filteredOptions = options.filter(option => option.label.includes(filterText));
    else this.filteredOptions = options;

    this.filteredOptions.forEach(option => this.optionsMap.set(option.id, option));
  }

  areAllSelected() {

  }

  ngOnChanges() {

    this.refreshFilterOptions('');
  }
  
  onCheck(event: MdbCheckboxChange, option: MultipleSelectOption) {
    let changedOption = this.optionsMap.get(option.id);
    changedOption.selected = event.checked;

    this.value = this.filteredOptions.filter(option => option.selected).map(option => this.useIndexValues ? this.filteredOptions.indexOf(option).toString() : option.id);

    this.updateValue();
  }

}